export const REAL_TIME_EVENT = 'configuration-update-event';
